<div [@routerTransition]>
    <sub-header [title]="('VendorPayments' | localize) + ' ' + ('Details' | localize)"
                [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="CustomerDisplayProperty">{{ l('Vendor') }}</label>
                            <app-search-vendor (vendorEvent)="getVendor($event)"
                                                 [vendorSelectedItem]="this.vendorSelectedItem"></app-search-vendor>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="vendorPayment_ReceiptDate">{{ l('ReceiptDate') }}</label>

                            <abp-datetime-picker #VendorPayment_ReceiptDate="ngModel"
                                                 [(ngModel)]="vendorPayment.receiptDate"
                                                 id="vendorPayment_ReceiptDate"
                                                 name="vendorPayment_ReceiptDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="VendorPayment_ReceiptDate"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group m-form__group">
                            <label for="PaymentTypeName">{{ l('PaymentType') }}</label>
                            <select name="vendorPayment.paymentTypeId"
                                    [(ngModel)]="vendorPayment.paymentTypeId"
                                    class="form-select">
                                <option value="null">{{ l('SelectAPaymentType') }}</option>

                                <option *ngFor="let item of allPaymentTypes" value="{{ item.id }}">
                                    {{ item.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_Reference">{{ l('Reference') }}</label>
                            <input type="text"
                                   #vendorPayment_Reference="ngModel"
                                   id="vendorPayment_Reference"
                                   class="form-control"
                                   [(ngModel)]="vendorPayment.reference"
                                   name="Reference" />
                            <validation-messages [formCtrl]="vendorPayment_Reference"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_TotalBalance">{{ l('TotalBalance') }}</label>
                            <input type="number"
                                   id="vendorPayment_TotalBalance"
                                   class="form-control text-end"
                                   [(ngModel)]="totalBalance"
                                   name="TotalBalance"
                                   disabled="disabled" />
                        </div>
                    </div>
                    <!-- <div class="col-md-2">
                        <div class="form-group pt-6">
                            <label for="vendorPayment_Amount">&nbsp;&nbsp;&nbsp;</label>
                            <input type="checkbox"
                                   #vendorPayment_IsPDCPayment="ngModel"
                                   id="vendorPayment_IsPDCPayment"
                                   class="form-check-input"
                                   [(ngModel)]="vendorPayment.isPDCPayment"
                                   name="IsPDCPayment" />
                            <label class="form-label" for="vendorPayment_IsPDCPayment"> &nbsp; {{ l('IsPDCPayment') }}</label>
                        </div>
                    </div> -->
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_PaymentDiscount">
                                {{ l('Discount') }}
                            </label>
                            <input type="number"
                                   #vendorPayment_PaymentDiscount="ngModel"
                                   id="vendorPayment_PaymentDiscount"
                                   class="form-control text-end"
                                   [(ngModel)]="vendorPayment.paymentDiscount"
                                   name="PaymentDiscount" (ngModelChange)="calculateTotalValue()" />
                            <validation-messages [formCtrl]="vendorPayment_PaymentDiscount"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_Amount">{{ l('Amount') }}</label>
                            <input type="number"
                                   #vendorPayment_Amount="ngModel"
                                   id="vendorPayment_Amount"
                                   class="form-control text-end"
                                   [(ngModel)]="vendorPayment.amount"
                                   name="Amount" disabled="disabled" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_Amount">{{ l('AppliedAmount') }}</label>
                            <input type="number"
                                   id="AppliedAmount"
                                   class="form-control text-end"
                                   [(ngModel)]="appliedAmount"
                                   name="Amount" disabled="disabled" />
                        </div>
                    </div>

                    <div class="col-md-8">
                        <div class="form-group">
                            <label for="vendorPayment_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   #vendorPayment_Remarks="ngModel"
                                   id="vendorPayment_Remarks"
                                   class="form-control"
                                   [(ngModel)]="vendorPayment.remarks"
                                   name="Remarks" />
                            <validation-messages [formCtrl]="vendorPayment_Remarks"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="vendorPayment_BalanceAmount">{{ l('BalanceAmount') }}</label>
                            <input type="number"
                                   id="vendorPayment_BalanceAmount"
                                   class="form-control text-end"
                                   [(ngModel)]="balanceAmount"
                                   name="Amount"
                                   disabled="disabled" />
                        </div>
                    </div>
                </div>
                <div class="row mt-10">
                    <div class="col-md-12">
                        <table class="table table-striped table-bordered col-xs-12">
                            <thead>
                                <tr>
                                    <th>{{ l('#') }}</th>
                                    <th>{{ l('TransactionNo') }}</th>
                                    <th>{{ l('Reference') }}</th>
                                    <th class="text-right">{{ l('TransactionType') }}</th>
                                    <th class="text-right">{{ l('Date') }}</th>
                                    <th class="text-right">{{ l('DueDate') }}</th>
                                    <th class="text-right">{{ l('Amount') }}</th>
                                    <th class="text-right">{{ l('Balance') }}</th>
                                    <th width="5%">{{ l('Apply') }}</th>
                                    <th class="text-right">{{ l('ApplyAmount') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of transactions; let index = index">
                                    <td>{{ index + 1 }}</td>
                                    <td class="col-xs-2">{{ data.transactionNo }}</td>
                                    <td class="col-xs-1">{{ data.referenceNo }}</td>
                                    <td class="col-xs-1"> {{ TransactionType[data.type] || 'N/A' }}</td>
                                    <td class="col-xs-1">{{ data.transactionDate | date: 'yyyy-MMM-dd' }}</td>
                                    <td class="col-xs-1">{{ data.dueDate | date: 'yyyy-MMM-dd' }}</td>
                                    <td class="col-xs-1 text-right">{{ data.amount | priceFormat }}</td>
                                    <td class="col-xs-1 text-right">{{ data.balanceAmount | priceFormat }}</td>

                                    <td class="col-xs-1 text-center">
                                        <input type="checkbox"
                                               [id]="'chkApply_' + index"
                                               [name]="'chkApply_' + index"
                                               [(ngModel)]="data.applied"
                                               [ngClass]="{ edited: data.applied }"
                                               (ngModelChange)="applyAmount(data)" />
                                    </td>

                                    <td class="col-xs-1 text-right">
                                        <input type="number"
                                               maxlength="10"
                                               class="form-control text-end"
                                               name="applyAmount"
                                               [(ngModel)]="data.appliedAmount"
                                               (ngModelChange)="calculateTotalValue()" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(paymentStatus.Paid)"
                            [hidden]="this.vendorPayment.id"
                            class="btn btn-primary blue me-2"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                    <button [hidden]="vendorPayment.status != paymentStatus.UnPaid"
                            (click)="save(paymentStatus.UnPaid)"
                            class="btn btn-primary blue float-right"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
